import styled from '@src/styled-components';

export const WidgetBox = styled.div`

width: 100%;
background: linear-gradient(87.23deg, #1A7BB1 -53.09%, rgba(255, 255, 255, 0) 182.08%), #77DEA0;
border-radius: 10px;
box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);



.up{
    padding: 15px;    
    color: white;
    position: relative;

    .title{
      width: 90%;
      font-family: "Montserrat";
      font-size: 15px;
      font-weight: normal;
      text-overflow: ellipsis;
      overflow: hidden; 
      height: 1.2em; 
      white-space: nowrap;
    }

    .delete, .edit{
      position: absolute;
      right: 15px;
      top: 15px;
      font-size: 18px; 
      &:hover{
        cursor: pointer;
      }
    }    
  }


&.-counter {

  .selected-style {
    position: absolute;
    font-size: 18px;
    right: 25px;
    top: 70px;
  }
.icon-style {
    margin-right: 15px;
  }
 .pipe-style {
   padding-left: 10px;
   padding-right: 10px;
 }
 .span-style {
   padding-left: 5px;
 }

  .bottom{
    display: flex;
    font-family: "Quicksand";
    font-weight: 500;
    flex: 6;
    align-items: center;
    justify-content: center;
    color: #FFF;
    height: 207px;
    border-top: solid 1px #FFFFFF;
    font-size: 130px;
  }
}

&.-list {
  .bottom{
    display: flex;
    font-family: "Montserrat";
    font-weight: 500;
    flex: 6;
    align-items: center;
    justify-content: center;    
    color: #7E7E7E;
    height: 207px;
    border-top: solid 1px #FFFFFF;
    background: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    
    .selected-style {
      position: absolute;
      font-size: 16px;
      right: 40px;
      top: 225px;
      color: #98999A;
    }
    .icon-style {
    margin-right: 15px;
    }
    .count-user-style {
        padding-left: 5px;
      }
    .pipe-style {
      padding-left: 10px;
      padding-right: 10px;
    }
    .span-style {
      padding-left: 5px;
    }

    
    .table-container {
      overflow-y: auto;
      width: 100%;
      height: 150px;
      padding-bottom: 5px;
      font-weight: bold;
      margin-top: -58px;
      border-bottom: 2px solid #F5F4F9;

      .table-name{
          width: 160px !important;
          text-align: center;
          border-right: 2px solid #F5F4F9;
      } 
      
      .list-item{
        list-style: none;
        margin: 10px 0;
      }
      .table-header{
        display: flex;
        background: #FFFFFF;
        font-family: Montserrat;
        
        h3{
          color: #7E7E7E;
          margin-top: 20px;
          font-size: 1.4em;
        }
        .left-side-title{
          align-items: center;
          justify-content: center;
          width: 160px;
          text-align: center;
        }
        .right-side-title{
          align-items: center;
          justify-content: center;
          border-left: solid 1px #F5F4F9;
          flex: 1;
          text-align: start;
          h3{
            margin-left: 30px;
          }
        }
      }

    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;      
      }      
    ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
      }      
    ::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
      }      
    ::-webkit-scrollbar-thumb:hover {
          background: #555;
      }

      table {
        width: 100%;
        margin: 0;
        tr {
          border-bottom: 2px solid #F5F4F9;
          td {
            padding: 15px 10px;
            &:first-child {
              width: 80px;
              text-align: center;
              border-right: 2px solid #F5F4F9;
            }
          }
          &:last-child {
            border: 0;
          }
        }
      }
    }    
  }

  &.-preview  {
    .selected-style {
    position: absolute;
    font-size: 16px;
    right: 50px;
    top: 260px;
    color: #98999A;
    }
  }
}

&.-barChart {
  height: 100%; 
  

.selected-style {
  position: absolute;
  font-size: 16px;
  right: 40px;
  top: 120px;
  color: #98999A;
}
.count-user-style {
    padding-left: 5px;
  }
 .pipe-style {
   padding-left: 10px;
   padding-right: 10px;
 }
 .span-style {
   padding-left: 5px;
 }

  &.-preview  {
    .selected-style {
    position: absolute;
    font-size: 16px;
    right: 40px;
    top: 155px;
    color: #98999A;
    }
    .bottom {
      overflow: auto;
      .canvasChart {
        width: 600px !important;
        height: 190px;
      }
    }
  }

  .bottom{
    background: white;
    border-radius: 0 0 10px 10px;
    overflow-y: auto;
    border-top: 1px solid #C4C4C4;
    padding: 20px;

    @media (max-width: 980px) {
      height: 200px !important;      
      overflow: scroll;

      .canvasChart {
        width: 980px !important;
        height: 400px;
      }
    }

    .canvasChart {
      width: 100%;
      height: 400px;
      padding-left: 70px;
      position: relative;

      .rotated-text {
        transform: rotate(270deg);
        display: block;
        left: -30px;
        top: 50%;
        position: absolute;
      }

      &.desactive {
        display: none;
      }
    }
    .tableChart {
      padding: 20px ;
      &.desactive {
        display: none;
      }

      

      width: 100%;

      table {
        width: 100%;

        tr {
          border-bottom: 1px solid #B5B5B5;

          td {
            padding: 10px;
          }
        }

        thead{
          tr {            
            td {
              &.first {
                width: 200px;
              };
              font-weight: bold;
              color: #7E7E7E;
              font-family: "Montserrat";
              font-size: 14px;
            }
          }
          
        }
        tbody {
          tr {
            &:nth-child(odd) {
              background: rgba(227, 235, 244, 0.4)
            }
            td {
              color: #0659D5;
              font-family: "Open Sans";
              font-size: 14px;
              &.first {
                font-weight: bold;
                color: #7E7E7E;
                font-family: "Montserrat";
                font-size: 14px;
              }
            }
          }
        }
      }
    }    
    overflow-x: auto;

    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;      
      }      
    ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
      }      
    ::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
      }      
    ::-webkit-scrollbar-thumb:hover {
          background: #555;
      }
    .buttons-chart {
      text-align: right;
      margin-bottom: 50px;
      width: 100%;

      label {
        border-color: #335D7C;
        color: #335D7C;
        &.ant-radio-button-wrapper-checked {
          background: #335D7C;
          border-color: #335D7C;
          color: #fff;
          box-shadow: -1px 0 0 0 #335D7C;
          &::before {
            background-color: #335D7C !important;
          }
        }        
      }
    }

  }
  
  .rotate-text{
    transform: rotate(270deg);
    margin: auto
  }

  
}
`


export const PopoverContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;

  .popover-row{
    display: flex;
    width: 100%;
    padding: 10px 15px;
    border-radius: 5px;

    .icon{
      flex: 2;
    }

    .text{
      flex: 8;
      p{
        font-weight: 600;
        margin-left: 15px;
        color: #595959;
      }
    }
  }

  .popover-row:hover{
    cursor: pointer;
    background-color: #E3F4F1;
    color: #29CEAE;
  }

  
`
